export default {
	accounts: {
		name: 'Konto | Konten',
		id: 'Konto-ID',
		journal: '@:entity.journal.name',
		approve_all_journals: 'Alle Buchungen geprüft',
		reject_all_journals: 'Alle Buchungen beanstanden',
		show_document: 'Dokument anzeigen',
		hide_document: 'Dokument ausblenden',
		default: 'Standard',
		reviews: 'Prüfungen',
		reviewed: 'geprüft',
		updated: 'aktualisiert',
		assign_reviewer: 'Prüfer festlegen',
		select_people_to_continue: 'Bitte markieren Sie Personen um fortzufahren',
		read: 'Lesend',
		write: 'Schreibend',
		accountingYear: 'Buchungsjahr',
		unit: 'VE',
	},
}
